import { render } from "./BaseItemLoader.vue?vue&type=template&id=b8c3be46&scoped=true"
import script from "./BaseItemLoader.vue?vue&type=script&lang=js"
export * from "./BaseItemLoader.vue?vue&type=script&lang=js"

import "./BaseItemLoader.vue?vue&type=style&index=0&id=b8c3be46&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8c3be46"]])

export default __exports__